import React from "react";

import Slider from "react-slick";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import "./SlideShow.css";

// import { WOW } from "wowjs";

const SlideShow = () => {

    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    return (
        <div
            id="mainSlideShow"
            className="ltn__slider-area ltn__slider-3 section-bg-2"
        >
            <Slider
                autoplay={true}
                autoplaySpeed={10000}
                pauseOnHover={false}
                pauseOnFocus={false}
                arrows={true}
                dots={true}
                fade={true}
                cssEase="linear"
                infinite={true}
                speed={300}
                slidesToShow={1}
                slidesToScroll={1}
                prevArrow={<button type="button" className="slick-prev"><i className="fas fa-arrow-left" alt="Arrow Icon"></i></button>}
                nextArrow={<button type="button" className="slick-next"><i className="fas fa-arrow-right" alt="Arrow Icon"></i></button>}
                responsive={[
                    {
                        breakpoint: 1200,
                        settings: {
                            arrows: false,
                            dots: true,
                        }
                    }
                ]}
                className="ltn__slide-one-active slick-slide-arrow-1 slick-slide-dots-1"
            >
                {/* <div className="ltn__slide-one-active slick-slide-arrow-1 slick-slide-dots-1"> */}
                {/* ltn__slide-item */}
                <div
                        className="ltn__slide-item ltn__slide-item-2  ltn__slide-item-3-normal--- ltn__slide-item-3 bg-image bg-overlay-personalized"
                        // style={{backgroundImage: `url('${publicUrl}assets/img/bg/img2.png')`}}
                        data-bs-bg={`${publicUrl}assets/img/slides/modern-villa-4.jpg`}
                    >
                        <div className="ltn__slide-item-inner  text-center">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 align-self-center">
                                        <div className="slide-item-info">
                                            <div className="slide-item-info-inner ltn__slide-animation">
                                                {/* <h6 className="slide-sub-title white-color--- animated">
                                                    <span>
                                                        <i className="fas fa-home" />
                                                    </span>{" "}
                                                    Agence TerganeTeranga
                                                </h6> */}
                                                <h3 className="slide-title animated">Des maisons qui vous ressemblent</h3>
                                                <div className="slide-brief animated">
                                                    {/* <p>Découvrez des propriétés uniques, alliant charme, confort et espaces généreux.</p> */}
                                                    <p>Explorez notre sélection de maisons spacieuses, lumineuses et adaptées à votre style de vie.</p>
                                                </div>
                                                <div className="btn-wrapper animated go-top">
                                                    <Link
                                                        to="/maisons"
                                                        className="theme-btn-1 btn btn-effect-1"
                                                    >
                                                        Découvrir
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ltn__slide-item */}
                    <div
                        className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal--- ltn__slide-item-3 bg-image bg-overlay-personalized"
                        // style={{backgroundImage: `url('${publicUrl}assets/img/bg/img-6.jpg')`}}
                        data-bs-bg={`${publicUrl}assets/img/slides/beautiful-living-room.jpg`}
                    >
                        <div className="ltn__slide-item-inner text-center">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 align-self-center">
                                        <div className="slide-item-info">
                                            <div className="slide-item-info-inner ltn__slide-animation">
                                                <div className="slide-video mb-50 d-none">
                                                    <a
                                                        className="ltn__video-icon-2 ltn__video-icon-2-border"
                                                        href="https://www.youtube.com/embed/tlThdr3O5Qo"
                                                        data-rel="lightcase:myCollection"
                                                    >
                                                        <i className="fa fa-play" />
                                                    </a>
                                                </div>
                                                {/* <h6 className="slide-sub-title white-color--- animated">
                                                    <span>
                                                        <i className="fas fa-home" />
                                                    </span>{" "}
                                                    Agence TerganeTeranga
                                                </h6> */}
                                                <h3 className="slide-title animated ">
                                                    De beaux appartements <br />{" "}
                                                    lumineux !
                                                </h3>
                                                <div className="slide-brief animated">
                                                    <p>Découvrez des appartements modernes, bien situés et conçus pour votre quotidien.</p>
                                                    {/* <p>Idéal pour les urbains en quête de praticité et de standing.</p> */}
                                                    {/* <p>Balcon, vue imprenable, espaces optimisés… Trouvez le logement qui allie confort et proximité avec tout ce qui compte pour vous.</p> */}
                                                </div>
                                                <div className="btn-wrapper animated go-top">
                                                    <Link
                                                        to="/appartements"
                                                        className="theme-btn-1 btn btn-effect-1"
                                                    >
                                                        Découvrir
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ltn__slide-item */}
                    <div
                        className="ltn__slide-item ltn__slide-item-2  ltn__slide-item-3-normal--- ltn__slide-item-3 bg-image bg-overlay-personalized"
                        // style={{backgroundImage: `url('${publicUrl}assets/img/bg/img-3.jpg')`}}
                        data-bs-bg={`${publicUrl}assets/img/slides/land.jpg`}
                    >
                        <div className="ltn__slide-item-inner  text-right text-center">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 align-self-center">
                                        <div className="slide-item-info">
                                            <div className="slide-item-info-inner ltn__slide-animation">
                                                {/* <h6 className="slide-sub-title white-color--- animated">
                                                    <span>
                                                        <i className="fas fa-home" />
                                                    </span>{" "}
                                                    Agence TerganeTeranga
                                                </h6> */}
                                                <h3 className="slide-title animated ">
                                                    Trouvez le terrain idéal
                                                    <br /> pour votre projet !
                                                </h3>
                                                <div className="slide-brief animated">
                                                    <p>Trouvez le terrain idéal pour réaliser votre projet de construction.</p>
                                                    {/* <p>Emplacements privilégiés, surfaces adaptées et potentiel illimité : votre rêve prend forme ici.</p> */}
                                                    {/* <p>Proches des commodités ou en pleine nature, nos terrains offrent des opportunités uniques pour construire ce qui vous ressemble.</p> */}
                                                    {/* <p>Faites le premier pas vers votre futur chez-vous.</p> */}
                                                </div>
                                                <div className="btn-wrapper animated go-top">
                                                    <Link
                                                        to="/terrains"
                                                        className="theme-btn-1 btn btn-effect-1"
                                                    >
                                                        Découvrir
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*  */}
                {/* </div> */}
            </Slider>
        </div>
    );
};

export default SlideShow;
